import React from 'react';
import { useIcons } from '../../utils/hooks';
import InformationPopUp from './InformationPopUp';
import Summary from './SummaryPopUp';

function SendFormPopUp({
	formType, // access, delegation, earlyVote, interventions
	formData,
	portal,
	sending,
	result,
	colors,
	translate,

	setOpen,
	onConfirm,
	onSuccess,
}) {
	/* Icon hook */
	const { CrossCircle: ErrorIcon, CheckCircle: SuccessIcon } = useIcons(colors);

	/* If success when sending */
	if (result === 1) {
		return <InformationPopUp
			data={portal?.config?.popUps?.submitSuccess}
			onClick={onSuccess}
			colors={colors}
			Icon={SuccessIcon}
			translate={translate}
		/>;
	}

	/* If error when sending */
	if (result === 2) {
		return <InformationPopUp
			data={portal?.config?.popUps?.submitFailure}
			onClick={() => setOpen(false)}
			colors={colors}
			Icon={ErrorIcon}
			translate={translate}
		/>;
	}
	/* If DNI and Email already exist */
	if (result === 3) {
		return <InformationPopUp
			data={portal?.config?.popUps?.emailDniFailure}
			onClick={() => setOpen(false)}
			colors={colors}
			Icon={ErrorIcon}
			translate={translate}
		/>;
	}
	/* If DNI already exist */
	if (result === 4) {
		return <InformationPopUp
			data={portal?.config?.popUps?.dniFailure}
			onClick={() => setOpen(false)}
			colors={colors}
			Icon={ErrorIcon}
			translate={translate}
		/>;
	}
	/* If Email already exist */
	if (result === 5) {
		return <InformationPopUp
			data={portal?.config?.popUps?.emailFailure}
			onClick={() => setOpen(false)}
			colors={colors}
			Icon={ErrorIcon}
			translate={translate}
		/>;
	}
	return <Summary
		formData={formData}
		translate={translate}
		portal={portal}
		formType={formType}
		sending={sending}
		onConfirm={onConfirm}
		setOpen={setOpen}
		colors={colors}
	/>;
}

export default SendFormPopUp;
